import { fullName } from '@shared';
import { OnboardingChrome } from '../components';
import { SlideContent } from '../components/SlideContent';
import { OnboardingFundingCoverage } from '.';
import { PolicyApplicationDashboard } from './PolicyApplicationDashboard';
import { selectClient } from '@client';
import { useSelector } from 'react-redux';

export function OnboardingPolicyApplicationDashboard({
  clientId,
}: ClientIdProps) {
  const client = useSelector(selectClient);
  const clientName = fullName(client);

  return (
    <OnboardingChrome
      slidePage={OnboardingPolicyApplicationDashboard}
      nextSlidePage={OnboardingFundingCoverage}
      nextButtonLabel="Next"
    >
      <SlideContent
        headerText={`Insurance Application Review `}
        headerSubText={`Review and manage insurance applications for ${clientName}.`}
        centerHeader={true}
      >
        <div className="mt-2 md:mt-8">
          <PolicyApplicationDashboard />
        </div>
      </SlideContent>
    </OnboardingChrome>
  );
}
